export default {
	ordflokkur: function(ofl) {
		let ordflokkar = {
			'kv.': 'kvk.',
			'ef. ft.': 'ef.ft.'
		}
		return (ordflokkar[ofl] || ofl);
	}
}
